'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebVTTConverter = function () {
  function WebVTTConverter(resource) {
    _classCallCheck(this, WebVTTConverter);

    this.resource = resource;
  }

  _createClass(WebVTTConverter, [{
    key: 'blobToBuffer',
    value: function blobToBuffer() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.addEventListener('loadend', function (event) {
          var buf = event.target.result;
          resolve(new Uint8Array(buf));
        });
        reader.addEventListener('error', function () {
          return reject('Error while reading the Blob object');
        });
        reader.readAsArrayBuffer(_this.resource);
      });
    }
    /**
     * @param {*} blob
     * @param {*} success
     * @param {*} fail
     */

  }, {
    key: 'getURL',
    value: function getURL() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        if (!(_this2.resource instanceof Blob)) return reject('Expecting resource to be a Blob but something else found.');
        if (!FileReader) return reject('No FileReader constructor found');
        if (!TextDecoder) return reject('No TextDecoder constructor found');
        return WebVTTConverter.blobToString(_this2.resource, function (decoded) {
          var vttString = 'WEBVTT FILE\r\n\r\n';
          var text = vttString.concat(WebVTTConverter.toVTT(decoded));
          var blob = new Blob([text], { type: 'text/vtt' });
          _this2.objectURL = URL.createObjectURL(blob);
          return resolve(_this2.objectURL);
        }, function () {
          _this2.blobToBuffer().then(function (buffer) {
            var utf8str = new TextDecoder('utf-8').decode(buffer);
            var vttString = 'WEBVTT FILE\r\n\r\n';
            var text = vttString.concat(WebVTTConverter.toVTT(utf8str));
            var blob = new Blob([text], { type: 'text/vtt' });
            _this2.objectURL = URL.createObjectURL(blob);
            return resolve(_this2.objectURL);
          });
        });
      });
    }
  }, {
    key: 'release',
    value: function release() {
      URL.createObjectURL(this.objectURL);
    }
  }], [{
    key: 'blobToString',
    value: function blobToString(blob, success, fail) {
      var reader = new FileReader();
      reader.addEventListener('loadend', function (event) {
        var text = event.target.result;
        success(text);
      });
      reader.addEventListener('error', function () {
        return fail();
      });
      reader.readAsText(blob);
    }
    /**
     * @param {*} utf8str
     */

  }, {
    key: 'toVTT',
    value: function toVTT(utf8str) {
      return utf8str.replace(/\{\\([ibu])\}/g, '</$1>').replace(/\{\\([ibu])1\}/g, '<$1>').replace(/\{([ibu])\}/g, '<$1>').replace(/\{\/([ibu])\}/g, '</$1>').replace(/(\d\d:\d\d:\d\d),(\d\d\d)/g, '$1.$2').concat('\r\n\r\n');
    }
    /**
     * @param {*} str
     */

  }, {
    key: 'toTypedArray',
    value: function toTypedArray(str) {
      var result = [];
      str.split('').forEach(function (each) {
        result.push(parseInt(each.charCodeAt(), 16));
      });
      return Uint8Array.from(result);
    }
  }]);

  return WebVTTConverter;
}();

window.WebVTTConverter = WebVTTConverter;

exports.default = WebVTTConverter;